(function () {
  if (window.__ekselansCategoryMenuInit) return;
  window.__ekselansCategoryMenuInit = true;

  function preserveSpecialUrls(root) {
    root.querySelectorAll('[data-ex-preserve-url]').forEach(function (link) {
      link.setAttribute('href', link.getAttribute('data-ex-preserve-url'));
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-ex-preserve-url]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.getAttribute('data-ex-preserve-url'));
  }, true);

  document.addEventListener('focusin', function (event) {
    var root = event.target.closest('[data-ex-menu]');
    if (root) preserveSpecialUrls(root);
  });

  function select(root, index) {
    preserveSpecialUrls(root);
    root.querySelectorAll('[data-ex-top]').forEach(function (row) {
      row.classList.toggle('is-active', row.getAttribute('data-ex-top') === index);
    });
    root.querySelectorAll('[data-ex-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-ex-panel') !== index;
    });
    if (root.classList.contains('ex-menu--mobile')) {
      root.classList.add('is-detail');
      root.scrollIntoView({ block: 'start' });
    } else {
      var panels = root.querySelector('.ex-menu__panels');
      if (panels) panels.scrollTop = 0;
    }
  }

  document.addEventListener('mouseover', function (event) {
    if (window.matchMedia('(max-width:1024px)').matches) return;
    var row = event.target.closest('.ex-menu--desktop [data-ex-top]');
    if (row) select(row.closest('[data-ex-menu]'), row.getAttribute('data-ex-top'));
  });

  document.addEventListener('click', function (event) {
    var root = event.target.closest('[data-ex-menu]');
    if (!root) return;
    var selected = event.target.closest('[data-ex-select]');
    if (selected) {
      event.preventDefault();
      select(root, selected.getAttribute('data-ex-select'));
      return;
    }
    var topLink = event.target.closest('.ex-menu__top-link');
    if (topLink && root.classList.contains('ex-menu--mobile') && topLink.closest('[data-ex-top]').querySelector('[data-ex-select]')) {
      event.preventDefault();
      select(root, topLink.closest('[data-ex-top]').getAttribute('data-ex-top'));
      return;
    }
    var toggle = event.target.closest('[data-ex-group-toggle]');
    if (toggle) {
      var card = toggle.closest('.ex-menu__group');
      var open = card.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    if (event.target.closest('[data-ex-back]')) {
      root.classList.remove('is-detail');
      root.scrollIntoView({ block: 'start' });
      return;
    }
    if (event.target.closest('[data-ex-close]')) {
      var vertical = root.closest('.vertical-menu--sol-men');
      if (vertical) {
        vertical.classList.remove('vertical-menu__open');
        vertical.classList.add('vertical-menu__hide');
        vertical.classList.add('ex-menu-closed');
      }
    }
  });

  document.addEventListener('mouseover', function (event) {
    var trigger = event.target.closest('.vertical-menu--sol-men .categories-title');
    if (trigger) trigger.closest('.vertical-menu--sol-men').classList.remove('ex-menu-closed');
  });
})();

